import React from 'react';
import CKEditor from 'react-ckeditor-component';

import {
  Input,
  Button,
  Select,
  notification,
  Collapse,
  Row,
  Col,
} from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, withApollo, compose } from 'react-apollo';

import LeyendaVariables from './LeyendaVariables';
import Loading from '../common/Loading';
import TablaParTalonarios from './TablaParTalonarios';
import { styles } from './HashtagSpan';

import getCategorias from '../../graphql/querys/editor/getCategorias.graphql';
import agregarModeloNotaCategoria from '../../graphql/mutations/editor/agregarModeloNotaCategoria.graphql';
import eliminarModeloNotaCategoria from '../../graphql/mutations/editor/eliminarModeloNotaCategoria.graphql';
import getCategoriasDeUnModelo from '../../graphql/querys/editor/getCategoriasPorModeloNota.graphql';

import getOrganismos from '../../graphql/querys/organismos/getOrganismos.graphql';
import getTalonarios from '../../graphql/querys/otros/getTalonarios.graphql';
import getClasificadoresEstadisticos from '../../graphql/querys/clasificadores/getClasificadoresEstadisticos.graphql';
import _ from 'lodash';

import config from '../../config';

const Panel = Collapse.Panel;

const CKEDITOR_URL = config.ckeditor;

@compose(
  graphql(agregarModeloNotaCategoria, {
    name: 'agregarCategoria',
  }),
  graphql(eliminarModeloNotaCategoria, {
    name: 'eliminarCategoria',
  }),
  graphql(getOrganismos, { options: { fetchPolicy: 'network-only' } }),
  graphql(getTalonarios, {
    name: 'talonarios',
  }),
  graphql(getClasificadoresEstadisticos, {
    name: 'clasificadoresEstadisticos',
  })
)
class Example extends React.Component {
  constructor(props) {
    super(props);
    this.updateContent = this.updateContent.bind(this);
    this.onChange = this.onChange.bind(this);
    this.generarOpcionesCategorias = this.generarOpcionesCategorias.bind(this);
    this.agregarNotaACategoria = this.agregarNotaACategoria.bind(this);
    this.eliminarNotaDeCategoria = this.eliminarNotaDeCategoria.bind(this);
    this.generarValoresPorDefecto = this.generarValoresPorDefecto.bind(this);
    this.state = {
      content: '',
      modelo_nota: {
        titulo: '',
        descripcion: '',
        categorias: [],
        htmlModelo: '',
        organismos: [],
        talonarios: [],
        clasificadoresEstadisticos: [],
      },
      categoriasTotal: [],
      loading: false,
      organismoSeleccionado: '',
      paresTalonariosSelector: [],
      paresPosibles: [],
      talonarioSeleccionado: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.data.getOrganismos && nextProps.data.getOrganismos) {
      this.generarOpcionesTalonarios(nextProps.data.getOrganismos);
    }
    if (this.props.data.getOrganismos) {
      this.generarOpcionesTalonarios(this.props.data.getOrganismos);
    }
  }

  componentDidMount() {
    const { htmlModelo } = this.props.modelo_nota;
    let mod = this.props.modelo_nota;

    if (!this.props.data.loading) {
      if (this.props.data.getOrganismos) {
        //Esto significa que ya tengo los organismos!
        this.generarOpcionesTalonarios(this.props.data.getOrganismos);
      }
    }

    if (htmlModelo) {
      this.setState(
        {
          ...this.state,
          content: htmlModelo,
          modelo_nota: mod,
        },
        function() {
          this.generarOpcionesCategorias();
        }
      );
    } else {
      this.setState({
        ...this.state,
        loading: true,
      });

      //Si estamos por crear una nueva nota, entonces debemos cargar las categorias solamente.
      this.props.client
        .query({
          query: getCategorias,
        })
        .then(respuesta => {
          let categorias = respuesta.data.getCategorias;
          this.setState({
            ...this.state,
            categoriasTotal: categorias,
            loading: false,
          });
        });
    }
  }

  updateContent(newContent) {
    this.setState({
      content: newContent,
    });
  }

  onChange(evt) {
    // console.log("onChange fired with event info: ", evt);
    var newContent = evt.editor.getData();
    this.setState({
      content: newContent,
    });
  }

  getModeloNota() {
    // eslint-disable-next-line react/no-string-refs
    let editor = this.refs.editor.editorInstance;
    // eslint-disable-next-line no-unused-vars
    let modelo_nota;
    return (modelo_nota = {
      ...this.state.modelo_nota,
      htmlModelo: editor.getData(),
    });
  }

  getHtmlEditor() {
    // eslint-disable-next-line react/no-string-refs
    let editor = this.refs.editor.editorInstance;
    return editor.getData();
  }

  generarOpcionesCategorias() {
    // console.log("entrando a generar las categorias!");
    if (this.state.categoriasTotal != 0) {
      return;
    }

    this.setState({
      // ...this.state,
      loading: true,
    });

    //Buscamos todas las categorias disponibles en la Base de datos.
    this.props.client
      .query({
        query: getCategorias,
      })
      .then(respuesta => {
        let categorias = respuesta.data.getCategorias;
        //Ahora, debemos buscar las categorias que un modelo de nota particular contiene
        //Para asi, poder asignarlas como "Ya cargadas" en el selector.
        this.props.client
          .query({
            query: getCategoriasDeUnModelo,
            variables: { idModeloNota: this.state.modelo_nota._id },
          })
          .then(respuestaCategorias => {
            let categoriasDeUnModelo =
              respuestaCategorias.data.getCategoriasDeUnModelo;

            this.setState(
              {
                ...this.state,
                modelo_nota: {
                  ...this.state.modelo_nota,
                  categorias: categoriasDeUnModelo,
                },
                categoriasTotal: categorias,
                loading: false,
              },
              function() {
                // console.log("Luego de actualizar el estado queda de la siguiente manera: ");
                // console.log(this.state);
              }
            );
          });
      });
  }

  agregarNotaACategoria(idCategoria) {
    this.props
      .agregarCategoria({
        variables: {
          idCategoria: idCategoria,
          idModeloNota: this.state.modelo_nota._id,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(respuesta => {
        notification.success({
          message: 'Categoria agregada',
          description: 'Se ha agregado la categoria a la nota exitosamente',
        });
      });
  }

  eliminarNotaDeCategoria(idCategoria) {
    this.props
      .eliminarCategoria({
        variables: {
          idCategoria: idCategoria,
          idModeloNota: this.state.modelo_nota._id,
        },
      })
      // eslint-disable-next-line no-unused-vars
      .then(respuesta => {
        notification.warning({
          message: 'Categoria eliminada',
          description: 'Se ha eliminado la categoria a la nota exitosamente',
        });
      });
  }

  generarValoresPorDefecto() {
    //Metodo que se encarga de generar el arreglo de valores para el selector multiple de categorias.
    let valores = [];
    this.state.modelo_nota.categorias.map(categoria => {
      valores.push(categoria._id);
    });
    return valores;
  }

  generarOpcionesTalonarios = organismos => {
    // console.log('ENTRE CON: ', organismos);
    let valores = [];
    if (organismos) {
      organismos.map(organismo => {
        valores[organismo._id] = organismo.talonarios;
      });
    }

    this.setState({
      paresPosibles: valores,
    });

    return valores;
  };

  generarClasificadoresPorDefecto = () => {
    //Metodo que se encarga de generar el arreglo de valores para el selector multiple de categorias.
    let valores = [];
    // console.log(this.state.modelo_nota);
    this.state.modelo_nota.clasificadoresEstadisticos.map(clasificador => {
      // console.log(clasificador);
      if (clasificador) {
        valores.push(clasificador._id);
      }
    });

    return valores;
  };

  agregarPar = () => {
    // console.log(this.state);

    let organismo = _.find(this.props.data.getOrganismos, {
      _id: this.state.organismoSeleccionado,
    });
    let talonario = _.find(
      this.state.paresPosibles[this.state.organismoSeleccionado],
      {
        _id: this.state.talonarioSeleccionado,
      }
    );

    if (organismo && talonario) {
      let obj = {
        organismo,
        talonario,
      };

      let orgs = [...this.state.modelo_nota.organismos] || [];

      if (
        !_.find(this.state.modelo_nota.talonarios, {
          organismo: { _id: this.state.organismoSeleccionado },
        })
      ) {
        orgs.push(organismo);
        this.setState({
          ...this.state,
          organismoSeleccionado: '',
          talonarioSeleccionado: '',
          modelo_nota: {
            ...this.state.modelo_nota,
            talonarios: _.concat(this.state.modelo_nota.talonarios, obj),
            organismos: orgs,
          },
        });
      } else {
        notification.warning({
          message: 'Ya existe el organismo',
          description:
            'El organismo que intenta agregar, ya fue agregado previamente. Si quiere modificar su talonario, primero proceda a su eliminación y vuelva a agregarlo.',
        });
        // console.log("YA EXISTE EL ORGANISMO");
      }
    } else {
      // console.log("DEBE SELECCIONAR UN ORGANISMO AL QUE SELECCIONAR Y SU TALONARIO");
      notification.error({
        message: 'Faltan datos',
        description:
          'Debe seleccionar un organismo y su talonario para poder agregarlo.',
      });
    }
  };

  removerPar = idOrganismo => {
    let copia = [...this.state.modelo_nota.talonarios];
    let nuevosPares = _.pullAllWith(copia, [idOrganismo], (valA, valB) => {
      return valA.organismo._id == valB;
    });

    // console.log(nuevosPares);
    this.setState({
      ...this.state,
      modelo_nota: {
        ...this.state.modelo_nota,
        talonarios: nuevosPares,
      },
    });
  };

  render() {
    let botones = null;
    let selectorCategorias = null;
    let selectorOrganismos = null;
    let selectorTalonarios = null;
    let selectorClasificadores = null;
    let botonAgregarPar = null;

    if (this.state.loading) {
      return <Loading />;
    }

    if (this.props.accion == 'crear') {
      botones = (
        <div className="divBotonesEditor">
          <Button
            type="primary"
            icon={<Icons.PrinterOutlined />}
            size="default"
            onClick={() => this.props.onSubmit(this.getModeloNota())}
          >
            Crear Modelo
          </Button>
          <Button
            type="danger"
            icon={<Icons.RollbackOutlined />}
            size="default"
            onClick={() => this.props.onCancel()}
          >
            Cancelar
          </Button>
        </div>
      );

      selectorCategorias = (
        <Select
          style={{ width: 400 }}
          id="categorias"
          mode="multiple"
          placeholder="Seleccione las categorias"
          defaultValue={
            this.state.modelo_nota.categorias && this.generarValoresPorDefecto()
          }
          onSelect={valor =>
            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                categorias: _.concat(this.state.modelo_nota.categorias, valor),
              },
            })
          }
          onDeselect={valor =>
            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                categorias: _.pull(this.state.modelo_nota.categorias, valor),
              },
            })
          }
        >
          {this.state.categoriasTotal &&
            this.state.categoriasTotal.map(categoria => (
              <Select.Option key={categoria._id}>
                {categoria.nombre}
              </Select.Option>
            ))}
        </Select>
      );

      selectorOrganismos = (
        <Select
          style={{ width: 400 }}
          id="organismos"
          // mode="multiple"
          placeholder="Seleccione los organismos"
          value={this.state.organismoSeleccionado}
          onSelect={valor =>
            this.setState({
              ...this.state,
              organismoSeleccionado: valor,
              talonarioSeleccionado: '',
              paresTalonariosSelector: _.get(this.state.paresPosibles, valor),
            })
          }
          onDeselect={valor =>
            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                organismos: _.pull(this.state.modelo_nota.organismos, valor),
              },
            })
          }
        >
          {this.props.data.getOrganismos &&
            this.props.data.getOrganismos.map(organismo => (
              <Select.Option key={organismo._id}>
                {organismo.nombre}
              </Select.Option>
            ))}
        </Select>
      );

      selectorTalonarios = (
        <Select
          style={{ width: 400 }}
          id="talonarios"
          ref={this.talonarios}
          placeholder="Seleccione el talonario"
          value={this.state.talonarioSeleccionado}
          defaultValue={
            this.state.modelo_nota.talonario
              ? this.state.modelo_nota.talonario._id
              : null
          }
          onSelect={valor =>
            this.setState({
              ...this.state,
              talonarioSeleccionado: valor,
            })
          }
        >
          {this.state.paresPosibles[this.state.organismoSeleccionado] &&
            this.state.paresPosibles[this.state.organismoSeleccionado].map(
              talonario => (
                <Select.Option key={talonario._id}>
                  {talonario.nombre}
                </Select.Option>
              )
            )}
        </Select>
      );

      selectorClasificadores = (
        <Select
          style={{ width: 400 }}
          id="clasificadores"
          mode="multiple"
          placeholder="Seleccione los clasificadores"
          defaultValue={
            this.state.modelo_nota.clasificadoresEstadisticos &&
            this.generarClasificadoresPorDefecto()
          }
          onSelect={valor =>
            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                clasificadoresEstadisticos: _.concat(
                  this.state.modelo_nota.clasificadoresEstadisticos,
                  valor
                ),
              },
            })
          }
          onDeselect={valor =>
            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                clasificadoresEstadisticos: _.pullAllWith(
                  [...this.state.modelo_nota.clasificadoresEstadisticos],
                  [valor],
                  (valA, valB) => {
                    return valA._id == valB;
                  }
                ),
              },
            })
          }
        >
          {this.props.clasificadoresEstadisticos
            .getClasificadoresEstadisticos &&
            this.props.clasificadoresEstadisticos.getClasificadoresEstadisticos.map(
              clasificador => (
                <Select.Option key={clasificador._id}>
                  {clasificador.nombre}
                </Select.Option>
              )
            )}
        </Select>
      );

      botonAgregarPar = (
        <Button onClick={this.agregarPar} type="primary">
          {' '}
          Agregar{' '}
        </Button>
      );
    }
    if (this.props.accion == 'actualizar') {
      botones = (
        <div className="divBotonesEditor">
          <Button
            type="primary"
            icon={<Icons.SaveOutlined />}
            size="default"
            onClick={() => this.props.onChange(this.getModeloNota())}
          >
            Guardar Cambios
          </Button>
          <Button
            type="danger"
            icon={<Icons.DeleteOutlined />}
            size="default"
            onClick={() => this.props.onDelete(this.getModeloNota()._id)}
          >
            {' '}
            Eliminar Modelo{' '}
          </Button>
          <Button
            type="primary"
            icon={<Icons.PrinterOutlined />}
            size="default"
            onClick={() => this.props.onImprimir(this.getHtmlEditor())}
          >
            Imprimir
          </Button>
          <Button
            type="danger"
            icon={<Icons.RollbackOutlined />}
            size="default"
            onClick={() => this.props.onCancel()}
          >
            Cancelar
          </Button>
        </div>
      );

      selectorCategorias = (
        <Select
          style={{ width: 400 }}
          id="categorias"
          mode="multiple"
          placeholder="Seleccione las categorias"
          defaultValue={
            this.state.modelo_nota.categorias && this.generarValoresPorDefecto()
          }
          onSelect={valor => this.agregarNotaACategoria(valor)}
          onDeselect={valor => this.eliminarNotaDeCategoria(valor)}
        >
          {this.state.categoriasTotal &&
            this.state.categoriasTotal.map(categoria => (
              <Select.Option key={categoria._id}>
                {categoria.nombre}
              </Select.Option>
            ))}
        </Select>
      );

      selectorOrganismos = (
        <Select
          style={{ width: 400 }}
          id="organismos"
          // mode="multiple"
          placeholder="Seleccione el organismo"
          value={
            this.state.organismoSeleccionado
              ? this.state.organismoSeleccionado
              : undefined
          }
          onSelect={valor =>
            this.setState({
              ...this.state,
              organismoSeleccionado: valor,
              talonarioSeleccionado: '',
              paresTalonariosSelector: _.get(this.state.paresPosibles, valor),
            })
          }
          onDeselect={valor => {
            var arr = [...this.state.modelo_nota.organismos];
            _.remove(arr, {
              _id: valor,
            });

            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                organismos: arr,
              },
            });
          }}
        >
          {this.props.data.getOrganismos &&
            this.props.data.getOrganismos.map(organismo => (
              <Select.Option key={organismo._id}>
                {organismo.nombre}
              </Select.Option>
            ))}
        </Select>
      );

      selectorTalonarios = (
        <Select
          style={{ width: 400 }}
          id="talonarios"
          ref={this.talonarios}
          placeholder="Seleccione el talonario"
          defaultValue={
            this.state.modelo_nota.talonario
              ? this.state.modelo_nota.talonario._id
              : null
          }
          value={this.state.talonarioSeleccionado}
          onSelect={valor =>
            this.setState({
              ...this.state,
              talonarioSeleccionado: valor,
            })
          }
        >
          {this.state.paresPosibles[this.state.organismoSeleccionado] &&
            this.state.paresPosibles[this.state.organismoSeleccionado].map(
              talonario => (
                <Select.Option key={talonario._id}>
                  {talonario.nombre}
                </Select.Option>
              )
            )}
        </Select>
      );

      selectorClasificadores = (
        <Select
          style={{ width: 400 }}
          id="clasificadores"
          mode="multiple"
          placeholder="Seleccione los clasificadores"
          defaultValue={
            this.state.modelo_nota.clasificadoresEstadisticos &&
            this.generarClasificadoresPorDefecto()
          }
          onSelect={valor =>
            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                clasificadoresEstadisticos: _.concat(
                  this.state.modelo_nota.clasificadoresEstadisticos,
                  valor
                ),
              },
            })
          }
          onDeselect={valor =>
            this.setState({
              ...this.state,
              modelo_nota: {
                ...this.state.modelo_nota,
                clasificadoresEstadisticos: _.pullAllWith(
                  [...this.state.modelo_nota.clasificadoresEstadisticos],
                  [valor],
                  (valA, valB) => {
                    return valA._id == valB;
                  }
                ),
              },
            })
          }
        >
          {this.props.clasificadoresEstadisticos
            .getClasificadoresEstadisticos &&
            this.props.clasificadoresEstadisticos.getClasificadoresEstadisticos.map(
              clasificador => (
                <Select.Option key={clasificador._id}>
                  {clasificador.nombre}
                </Select.Option>
              )
            )}
        </Select>
      );

      botonAgregarPar = (
        <Button onClick={this.agregarPar} type="primary">
          {' '}
          Agregar{' '}
        </Button>
      );
    }

    if (this.props.accion == 'visualizar') {
      botones = (
        <div className="divBotonesEditor">
          <Button
            type="primary"
            icon={<Icons.SaveOutlined />}
            size="default"
            loading={this.props.loading}
            onClick={() => {
              console.log(this.getHtmlEditor());
              this.props.onGuardar(this.getHtmlEditor())
            }}
          >
            Guardar
          </Button>
          <Button
            type="primary"
            icon={<Icons.PrinterOutlined />}
            size="default"
            loading={this.props.loading}
            onClick={() => this.props.onImprimir(this.getHtmlEditor())}
          >
            Guardar e Imprimir
          </Button>
          <Button
            type="danger"
            icon={<Icons.RollbackOutlined />}
            size="default"
            loading={this.props.loading}
            onClick={() => this.props.onCancel()}
          >
            Salir
          </Button>
        </div>
      );
    }

    if (this.props.accion == 'imprimir') {
      botones = (
        <div className="divBotonesEditor">
          <Button
            type="primary"
            icon={<Icons.PrinterOutlined />}
            size="default"
            onClick={() => this.props.onImprimir(this.getHtmlEditor())}
          >
            Imprimir
          </Button>
          <Button
            type="danger"
            icon={<Icons.RollbackOutlined />}
            size="default"
            onClick={() => this.props.onCancel()}
          >
            Salir
          </Button>
        </div>
      );
    }

    return (
      <div style={styles.root}>
        {this.props.accion != 'visualizar' && this.props.accion != 'imprimir' && (
          <Collapse bordered={false}>
            <Panel header="Variables posibles de utilizar" key="1">
              <LeyendaVariables />
            </Panel>
          </Collapse>
        )}

        {this.props.accion != 'visualizar' &&
        this.props.accion != 'imprimir' ? (
          <div>
            <div className="inputs">
              <h3>Titulo: </h3>
              <Input
                id="titulo"
                /* eslint-disable-next-line react/no-string-refs */
                ref="titulo"
                value={this.state.modelo_nota.titulo}
                placeholder="Ingrese el titulo del modelo"
                onChange={e =>
                  this.setState({
                    modelo_nota: {
                      ...this.state.modelo_nota,
                      titulo: e.target.value,
                    },
                  })
                }
              />
            </div>
            <div className="inputs">
              <h3>Descripcion: </h3>
              <Input
                id="descripcion"
                /* eslint-disable-next-line react/no-string-refs */
                ref="descripcion"
                value={this.state.modelo_nota.descripcion}
                placeholder="Ingrese una pequeña descripcion del modelo"
                onChange={e =>
                  this.setState({
                    modelo_nota: {
                      ...this.state.modelo_nota,
                      descripcion: e.target.value,
                    },
                  })
                }
              />
            </div>

            <Row>
              <Col span={10}>
                <div className="inputs">
                  <h3>Categorias: </h3>
                  {selectorCategorias}
                </div>
              </Col>

              <Col span={10}>
                <div className="inputs">
                  <h3>Clasificadores: </h3>
                  {selectorClasificadores}
                </div>
              </Col>
            </Row>

            {/* <Row>
                <Col span={12}>
                  <div className="inputs">
                    <h3>Clasificadores: </h3>
                    {selectorClasificadores}
                  </div>
                </Col>
              </Row> */}

            <Row>
              <Col span={10}>
                <div className="inputs">
                  <h3>Organismo del Talonario: </h3>
                  {selectorOrganismos}
                </div>
              </Col>
              <Col span={10}>
                <div className="inputs">
                  <h3>Talonario a Agregar: </h3>
                  {selectorTalonarios}
                </div>
              </Col>

              <Col span={4}>
                <div className="inputs">
                  <h3> Agregar Talonario: </h3>
                  {botonAgregarPar}
                </div>
              </Col>
            </Row>

            <br />

            {this.state.modelo_nota.talonarios.length > 0 && (
              <Row>
                <Col span={24}>
                  <h3>
                    Cantidad de Talonarios:{' '}
                    {this.state.modelo_nota.talonarios.length}
                  </h3>
                </Col>
              </Row>
            )}

            <br />

            {this.state.modelo_nota.talonarios.length > 0 && (
              <Row>
                <Col span={24}>
                  <TablaParTalonarios
                    removerPar={this.removerPar}
                    pares={this.state.modelo_nota.talonarios}
                  />
                </Col>
              </Row>
            )}
          </div>
        ) : null}
        <div style={styles.editor}>
          <CKEditor
            /* eslint-disable-next-line react/no-string-refs */
            ref="editor"
            activeClass="p10"
            content={this.state.content}
            events={{
              change: this.onChange,
            }}
            scriptUrl={CKEDITOR_URL}
            // scriptUrl={
            //   Meteor.isDevelopment
            //     ? "/ckeditor/ckeditor.js"
            //     : "/sijup/ckeditor/ckeditor.js"
            // }
            config={{
              allowedContent: true, // Allow all content (including SVG)
              extraAllowedContent: 'svg[*]{*}[*];path[*]{*}[*]', // Explicitly allow SVG and path tags with any attributes
              height: 800,
              language: 'es',
              removeButtons:
                'Source,NewPage,Print,Templates,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CreateDiv,Smiley,Iframe,About,Flash',
            }}
          />
        </div>

        {/* {
						this.props.accion != "visualizar" ? <div>
								<button onClick={() => this.mostrarDatos()}> Mostrar datos. </button>
								<button onClick={() => this.cargarTemplate()}> Cargar Template. </button>
						</div> : null
				} */}

        {botones}
      </div>
    );
  }
}

export default withApollo(Example);
